export const API_BASE_URL = "https://learnwebacademy.net/learnweb-api";
export const FILE_UPLOAD_URL = "https://learnwebacademy.net/assets";